export const INVALID_VIN_MSG =
  'Invalid VIN or vehicle not found. Please verify your entry and try again';
